// lib/client/fetchJson.js
'use client';

function getCsrf() {
  const m = document.cookie.split('; ').find((p) => p.startsWith('csrf='));
  return m ? decodeURIComponent(m.split('=')[1]) : null;
}

export async function fetchJson(url, { method = 'GET', headers = {}, body, ...rest } = {}) {
  const opts = { method, headers: { ...headers }, cache: 'no-store', ...rest };
  if (method !== 'GET' && method !== 'HEAD') {
    const csrf = getCsrf();
    if (csrf) opts.headers['x-csrf'] = csrf;
    if (body && !(body instanceof FormData)) {
      opts.headers['Content-Type'] = opts.headers['Content-Type'] || 'application/json';
      opts.body = typeof body === 'string' ? body : JSON.stringify(body);
    }
  }
  const res = await fetch(url, opts);
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json?.error || res.statusText);
    err.status = res.status;
    err.body = json;
    throw err;
  }
  return json;
}

export async function fetchJsonWithRefresh(url, opts) {
  try {
    return await fetchJson(url, opts);
  } catch (err) {
    if (err.status === 401) {
      await fetch('/api/auth/refresh', { method: 'POST', cache: 'no-store' });
      return fetchJson(url, opts);
    }
    throw err;
  }
}
